const { cxt } = require('./context');

const invoiceNumber = [
  'whitespace',
  cxt('pattern', { pattern: /^[A-Za-z0-9-]+$/ }),
];

module.exports = {
  invoiceNumber,
};
